<template>
  <div class="open-text">
    {{ $route.query.openid }}
  </div>
</template>

<script>
export default {
  name: 'OpenIdPage'
}
</script>

<style scoped lang="scss">
.open-text {
  font-size: 15px;
}
</style>
